import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAlbumPrintPackageCartItem } from '../../../../../services/checkout/redux/helpers';
import AlbumPrintPackageOption from '../AlbumPrintPackageOption';

const propTypes = {
  activeIdentity: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    prepaid_photo_pricings_enabled: PropTypes.bool,
  }).isRequired,
  printPackages: PropTypes.array.isRequired,
  onCartItemUpdate: PropTypes.func.isRequired,
  onAlbumPrintPackageToggle: PropTypes.func.isRequired,
  cart: PropTypes.object.isRequired,
};

const PrintPackagesItemsSelector = ({
  activeIdentity,
  albumFolder,
  printPackages,
  onCartItemUpdate,
  onAlbumPrintPackageToggle,
  cart,
}) => {
  if (
    !printPackages ||
    printPackages?.length === 0 ||
    !albumFolder?.prepaid_print_packages_enabled
  ) {
    return null;
  }

  return (
    <Fragment>
      <h4 className="mt-2">Print Packages</h4>
      {printPackages.map(albumFolderPrintPackage => (
        <AlbumPrintPackageOption
          key={albumFolderPrintPackage.id}
          albumPrintPackage={albumFolderPrintPackage}
          cartItem={getAlbumPrintPackageCartItem(cart, {
            albumPrintPackageId: albumFolderPrintPackage.id,
            identityId: activeIdentity?.id,
          })}
          onAlbumPrintPackageToggle={() =>
            onAlbumPrintPackageToggle({
              albumPrintPackage: albumFolderPrintPackage,
              identity: activeIdentity,
              prePaid: true,
            })
          }
          onUpdate={onCartItemUpdate}
        />
      ))}
    </Fragment>
  );
};

PrintPackagesItemsSelector.propTypes = propTypes;

export default PrintPackagesItemsSelector;
